// ThemeContext.js
import React, { createContext, useContext, useState } from 'react';

const ThemeContext = createContext();

export const useThemeContext = () => useContext(ThemeContext);

export const ThemeContextProvider = ({ children }) => {
  const [theme, setTheme] = useState('light');

  const updateTheme = (newTheme) => {
    localStorage.setItem('theme', newTheme);
    setTheme(newTheme);
  };

  const getCurrentTheme = () => {
    try {
      const storedTheme = localStorage.getItem('theme');
      return storedTheme || 'light';
    } catch (error) {
      return 'light';
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, updateTheme, getCurrentTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
